import Navbar from "@/components/Navbar";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Events from "@/components/Events";
import Schedule from "@/components/Schedule";
import Guidelines from "@/components/Guidelines";
import Team from "@/components/Team";
import Register from "@/components/Register";
import Footer from "@/components/Footer";

export default function Landing() {
  return (
    <main data-testid="landing-page" className="relative">
      <Navbar />
      <Hero />
      <About />
      <Events />
      <Schedule />
      <Guidelines />
      <Team />
      <Register />
      <Footer />
    </main>
  );
}
